module.exports = __webpack_public_path__ + "static/media/add_email_flows.c6d83403.png";